import { Directive, Input, TemplateRef } from '@angular/core';

/**
 * Project a custom cell template into acan-table by templateKey.
 * Usage: <ng-template acanCell="status" let-row let-col="col">...</ng-template>
 */
@Directive({
  selector: '[acanCell]',
  standalone: false,
})
export class AcanCellDirective {
  @Input('acanCell') templateKey = '';

  constructor(public readonly template: TemplateRef<unknown>) {}
}
